import { useState } from 'react'

/** A read-only value with a copy button, for one-time secrets and links. */
export function CopyField({ value, label }: { value: string; label: string }) {
	const [copied, setCopied] = useState(false)
	return (
		<div className="row">
			<input
				readOnly
				aria-label={label}
				value={value}
				onFocus={(e) => e.target.select()}
				style={{ flex: 1, fontFamily: 'var(--mono)', fontSize: '0.85rem' }}
			/>
			<button
				type="button"
				onClick={async () => {
					await navigator.clipboard?.writeText(value)
					setCopied(true)
				}}
			>
				{copied ? 'Copied' : 'Copy'}
			</button>
		</div>
	)
}
